import script from "./multipleItem.vue?vue&type=script&lang=ts&setup=true&name=ViewMultipleItem"
export * from "./multipleItem.vue?vue&type=script&lang=ts&setup=true&name=ViewMultipleItem"

import "./multipleItem.vue?vue&type=style&index=0&id=2f4cc7a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f4cc7a0"]])

export default __exports__